export const COMPANIES_PAGE = {
    'COMPANIES.PAGE.TITLE': 'Companii',
    'COMPANY.ADD.MODAL.TITLE': 'Companie nouă',
    'COMPANY.EDIT.MODAL.TITLE': 'Editare companie',
    'COMPANY.DISPLAY.MODAL.TITLE': 'Detalii companie'
};
